
import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import { colorTheme, muiTheme } from '@styles/muiTheme';

export const UploadFileWrapper = styled(Box)<{ bordercolor: string }>(
  ({ bordercolor }) => `
	border: ${bordercolor};
	padding: 5px;
	border-radius: 8px;
	max-height: 50px;
  `
);

export const UploadFileError = styled.div`
  color: ${muiTheme.palette.error.main};
  font-size: 0.75rem;
  font-family: 'Open Sans', Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
`;

export const FileUploadTypography = styled(Typography)`
  color: ${colorTheme.palette.primary.main};
  margin-top: 5px;
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
